// i18n area 'auth' — locale et-EE (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/auth.et-EE.meta.json.
import type { enUS } from './auth'

export const etEE: typeof enUS = {
  login: {
    welcome: 'Trantor TVirt v6',
    subtitle: 'Logi oma kontole sisse',
    username: 'Kasutajanimi',
    usernamePlaceholder: 'Sisesta kasutajanimi',
    usernameHint: 'Kataloogi realmi vastu sisselogimiseks kasuta kuju kasutaja@domeen',
    continue: 'Jätka',
    changeUser: 'Kas see pole sina?',
    password: 'Parool',
    forgotPassword: 'Unustasid parooli?',
    submit: 'Logi sisse',
    otp: 'Ühekordne kood',
    otpSubtitle: 'Sisesta oma autentikaatori kood',
    otpHint: 'Kuus numbrit autentimisrakendusest või üks sinu taastekoodidest',
    otpSubmit: 'Kontrolli',
    invalidCredentials: 'Vale kasutajanimi või parool',
    tooManyAttempts: 'Liiga palju katseid — oota hetk ja proovi uuesti',
    realmUnavailable: 'Realm ei saa praegu mandaate kontrollida — klastri store pole kättesaadav. Logi sisse kohaliku kasutajana (break-glass).',
    genericError: 'Sisselogimine ebaõnnestus — kas TVirti backend on kättesaadav?'
  },
  user: {
    logout: 'Logi välja',
    password: {
      menu: 'Muuda parooli',
      title: 'Muuda oma parooli',
      current: 'Praegune parool',
      new: 'Uus parool',
      confirm: 'Kinnita uus parool',
      mismatch: 'Paroolid ei kattu',
      error: 'Parooli muutmine ebaõnnestus',
      forcedTitle: 'Jätkamiseks muuda parooli',
      forcedHint: 'Selle parooli määras administraator ja see tuleb enne sisenemist asendada.',
      forcedSubmit: 'Muuda ja sisene'
    },
    mfa: {
      title: 'Kahefaktoriline autentimine',
      subtitle: 'Teine faktor, mida küsitakse igal sisselogimisel',
      loadError: 'Teise faktori oleku laadimine ebaõnnestus',
      enrolled: 'Aktiivne',
      notEnrolled: 'Pole aktiivne',
      enrolledAt: 'Aktiveeritud',
      codesRemaining: 'Taastekoode alles',
      requiredHint:
        'Administraator nõuab sellel kontol teist faktorit: seadista see kohe — kuni sa seda ei tee, saad küll sisse logida, kuid vähe muud teha.',
      enroll: 'Seadista',
      enrollTitle: 'Seadista kahefaktoriline autentimine',
      enrollHint: 'Skanni see kood autentimisrakendusega ja sisesta kinnitamiseks kood, mille rakendus näitab.',
      secretHint: 'Ei õnnestu skannida? Sisesta rakendusse see salavõti:',
      code: 'Rakenduse kood',
      confirm: 'Kinnita',
      startError: 'Seadistamise alustamine ebaõnnestus',
      confirmError: 'Seadistuse kinnitamine ebaõnnestus',
      codesTitle: 'Sinu taastekoodid',
      codesWarning:
        'Neid koode näidatakse ainult üks kord. Salvesta need kohe: iga kood laseb sind sisse, kui autentikaator pole saadaval, ja kehtib ühe korra.',
      codesAck: 'Olen taastekoodid salvestanud',
      codesDone: 'Valmis',
      copy: 'Kopeeri',
      copied: 'Kopeeritud',
      download: 'Laadi alla',
      regenerate: 'Uued taastekoodid',
      regenerateTitle: 'Genereeri taastekoodid uuesti',
      regenerateHint: 'Kõik seni väljastatud koodid lakkavad kehtimast hetkel, mil uus komplekt genereeritakse.',
      regenerateConfirm: 'Genereeri uuesti',
      regenerateError: 'Taastekoodide uuesti genereerimine ebaõnnestus',
      remove: 'Eemalda',
      removeTitle: 'Eemalda teine faktor',
      removeConfirm: 'Eemalda',
      removeHint: 'Konto jääb ainult parooli peale. Teise faktori saad igal ajal uuesti seadistada.',
      removeRequiredHint:
        'Administraator nõuab sellel kontol teist faktorit, seega server keeldub selle eemaldamisest — palu tal esmalt nõue tühistada.',
      removeError: 'Teise faktori eemaldamine ebaõnnestus'
    },
    profile: {
      menu: 'Ava minu profiil',
      sessions: 'Aktiivsed seansid',
      sessionsHint: 'Sinu avatud seansid selles sõlmes',
      sessionsEmpty: 'Aktiivsed seansid puuduvad',
      sessionCreated: 'Sisse logitud',
      sessionExpires: 'Aegub',
      revoke: 'Tühista seanss',
      revokeError: 'Seansi tühistamine ebaõnnestus',
      loadError: 'Seansside laadimine ebaõnnestus'
    }
  }
}
